import angular from 'angular';
import template from './template.html';
import './style.scss';

export class tftHelpPopup {
    isNeedToShow = false

    onMouseEnterHelpingIcon() {
        this.isNeedToShow = true;
    }

    onMouseLeaveHelpingIcon() {
        this.isNeedToShow = false;
    }
}

export const tftHelpPopupConfiguration = {
    template,
    bindings: {
        textPop: '@',
    },
    controller: tftHelpPopup,
    controllerAs: 'tftHelpPopupCtrl',
};

angular
    .module('TALENYA-FE')
    .component('tftHelpPopup', tftHelpPopupConfiguration);
